import { createTypes } from '../../utils';

const types = createTypes('successOverlay', [
    'SO_SET_SUCCESS_OVERLAY',
    'SO_SET_PARAM_MAIL_PROVIDER',
    'SO_SET_PARAM_SEND_CONFIRMATION_EMAIL',
    'SO_SET_ALERT',
    'SO_CLEAR_ALERT'
]);

export default types;
